import { Injectable } from '@angular/core';
import { ServiceFactoryService } from 'src/app/_services/service-factory.service';
import { DataSourceRequest } from '../eventer-grid/grid-options';

@Injectable({
  providedIn: 'root',
})
export class GridRequesterService {
  constructor(private serviceFactory: ServiceFactoryService) {}

  getPage<T>(url: string, request: DataSourceRequest | null) {
    return this.serviceFactory.appPost<T>(url, request, false);
  }
}
